import {
  Input,
  FormField,
  SpaceBetween,
  DatePicker,
  Select,
  Container,
  Textarea,
  ColumnLayout,
  Box,
  Link,
} from "@cloudscape-design/components-themed";
import { LABELS } from "./constants";

export const FormBlock = (props: any) => {
  return (
    <SpaceBetween direction="vertical" size="l">
      <ColumnLayout columns={2}>
        <FormField
          label={LABELS.START_DATE}
          errorText={props.conversionStartDataErrorMsg}
        >
          <DatePicker
            onChange={({ detail }) =>
              props.onChangApplicationStartDate(detail.value)
            }
            value={props.applicationStartDate}
            openCalendarAriaLabel={(selectedDate) =>
              "Choose certificate expiry date" +
              (selectedDate ? `, selected date is ${selectedDate}` : "")
            }
            nextMonthAriaLabel="Next month"
            placeholder="YYYY/MM/DD"
            previousMonthAriaLabel="Previous month"
            todayAriaLabel="Today"
            readOnly={props.readOnly}
          />
        </FormField>
        <Box float="right">
          {props.commercialData && (
            <Link onFollow={props.onClickCommercialApplicationInfo}>
              {LABELS.SHOW_INDUSTRY_CONVERSIONS_INFO}
            </Link>
          )}
        </Box>
      </ColumnLayout>
      <SpaceBetween direction="horizontal" size="l">
        <FormField label={LABELS.RULE_NO}>
          <Input
            onChange={({ detail }) => props.setRuleNo(detail.value)}
            value={props.ruleNo}
            readOnly
          />
        </FormField>
      </SpaceBetween>
      <FormField
        label={LABELS.BEFORE_CONVERSION}
        stretch={true}
        errorText={props.beforeConversionErrorMsg}
      >
        <Input
          onChange={({ detail }) =>
            props.onChangeBeforeConversion(detail.value)
          }
          value={props.beforeConversion}
          readOnly={props.readOnly}
        />
      </FormField>
      <SpaceBetween direction="horizontal" size="l">
        <FormField
          label={LABELS.AFTER_CONVERSION}
          stretch={true}
          errorText={props.afterConversionErrorMsg}
        >
          {props.readOnly ? (
            <Select
              selectedOption={props.afterConversion}
              onChange={() => {}}
            />
          ) : (
            <Select
              selectedOption={props.afterConversion}
              filteringType="auto"
              onChange={({ detail }) =>
                props.onChangeAfterConversion(detail.selectedOption)
              }
              options={props.afterConversionItems}
              selectedAriaLabel="Selected"
            />
          )}
        </FormField>
      </SpaceBetween>
    </SpaceBetween>
  );
};

export const Comment = (props: any) => {
  return (
    <Container>
      <SpaceBetween direction="vertical" size="l">
        <FormField label={LABELS.LATEST_COMMENT} stretch={true}>
          <Textarea value={props.actionComment} readOnly />
        </FormField>
        <FormField
          label={LABELS.COMMENT}
          stretch={true}
          errorText={props.commentErrorMsg}
        >
          <Textarea
            onChange={({ detail }) => props.onChangeComment(detail.value)}
            value={props.comment}
          />
        </FormField>
      </SpaceBetween>
    </Container>
  );
};
